__turbopack_context__.v({
  "area": "s64FwG_area",
  "axis": "s64FwG_axis",
  "axisOn": "s64FwG_axisOn",
  "band": "s64FwG_band",
  "chart": "s64FwG_chart",
  "down": "s64FwG_down",
  "grid": "s64FwG_grid",
  "head": "s64FwG_head",
  "line": "s64FwG_line",
  "peak": "s64FwG_peak",
  "point": "s64FwG_point",
  "root": "s64FwG_root",
  "stat": "s64FwG_stat",
  "statLabel": "s64FwG_statLabel",
  "statValue": "s64FwG_statValue",
  "stats": "s64FwG_stats",
  "tip": "s64FwG_tip",
  "tipMove": "s64FwG_tipMove",
  "tipOn": "s64FwG_tipOn",
  "tipRow": "s64FwG_tipRow",
  "unit": "s64FwG_unit",
  "unitGroup": "s64FwG_unitGroup",
  "unitItem": "s64FwG_unitItem",
  "up": "s64FwG_up",
  "value": "s64FwG_value",
});
